// extracted by mini-css-extract-plugin
export default {"buttonLabel":"K7_4X"};